import { createStore } from 'effector';

export const $sectorsList = createStore({ count: 0, data: [] });

export const $MatrixProjectData = createStore(null);
export const $MatrixProjectConSheet = createStore({ count: 0, data: [] });
export const $MatrixProjectConSheetFilters = createStore({});
